import { jsxs as h, jsx as e, Fragment as V } from "react/jsx-runtime";
import { forwardRef as L, useId as $, Children as re, isValidElement as oe, cloneElement as ie, createContext as q, useRef as B, useContext as Z, useMemo as A, useEffect as I, useState as _, useCallback as le } from "react";
import { CheckCircle2 as O, XCircle as F, AlertTriangle as P, Info as G, X as D, BarChart3 as se, Tag as ae, List as ce, Grid3x3 as de, Layers as ue, Map as fe, HelpCircle as he, CreditCard as pe, Download as me, Truck as ge, RefreshCw as ye, LogOut as be, KeyRound as ve, Lock as xe, EyeOff as we, Eye as Se, Clock as Ce, ArrowDown as ke, ArrowUp as Ee, ArrowRight as ze, ChevronRight as Re, ChevronLeft as Te, ChevronUp as Ne, ChevronDown as Be, Check as Ie, Minus as Le, Plus as Ae, MoreHorizontal as Pe, Copy as De, Trash2 as Me, Edit3 as We, Filter as _e, Search as je, SlidersHorizontal as $e, Settings as Oe, Bell as Fe, QrCode as Ge, Link as He, Mail as Ue, Star as Xe, Shield as Ye, Users as Ke, User as Ve, Store as qe, Building2 as Ze, Warehouse as Qe, Receipt as Je, ShoppingCart as U, Boxes as en, Box as nn, Package as tn } from "lucide-react";
import { createPortal as Q } from "react-dom";
const rn = {
  primary: "btn--primary",
  secondary: "btn--secondary",
  ghost: "btn--ghost",
  danger: "btn--danger",
  link: "btn--link"
}, on = {
  sm: "btn--sm",
  lg: "btn--lg"
  // md — default, без класса
};
function ln() {
  return /* @__PURE__ */ e(
    "span",
    {
      "aria-hidden": "true",
      style: {
        display: "inline-block",
        width: 14,
        height: 14,
        border: "2px solid currentColor",
        borderRightColor: "transparent",
        borderRadius: "50%",
        animation: "dss-btn-spin 720ms linear infinite"
      }
    }
  );
}
const Nn = L(function({
  variant: t = "secondary",
  size: r = "md",
  loading: o = !1,
  fullWidth: i = !1,
  leadingIcon: l,
  trailingIcon: u,
  iconOnly: c = !1,
  disabled: d,
  className: f,
  children: m,
  style: y,
  type: w = "button",
  ...R
}, C) {
  const b = [
    "btn",
    rn[t],
    on[r],
    c ? "btn--icon" : null,
    f
  ].filter(Boolean).join(" "), a = i ? { width: "100%", justifyContent: "center", ...y } : y;
  return /* @__PURE__ */ h(
    "button",
    {
      ref: C,
      type: w,
      className: b,
      disabled: d || o,
      "aria-busy": o || void 0,
      style: a,
      ...R,
      children: [
        o ? /* @__PURE__ */ e(ln, {}) : /* @__PURE__ */ h(V, { children: [
          l,
          !c && m,
          u
        ] }),
        /* @__PURE__ */ e("style", { children: "@keyframes dss-btn-spin { to { transform: rotate(360deg); } }" })
      ]
    }
  );
}), sn = L(function({ invalid: t = !1, className: r, ...o }, i) {
  const l = ["input", t ? "input--invalid" : null, r].filter(Boolean).join(" ");
  return /* @__PURE__ */ e("input", { ref: i, className: l, "aria-invalid": t || void 0, ...o });
}), Bn = L(function({ leadingIcon: t, trailing: r, invalid: o = !1, fullWidth: i = !0, className: l, style: u, ...c }, d) {
  const f = ["input-group", o ? "input-group--invalid" : null, l].filter(Boolean).join(" "), m = {
    ...i ? { width: "100%" } : null,
    ...o ? {
      borderColor: "var(--color-danger-solid)"
    } : null,
    ...u
  };
  return /* @__PURE__ */ h("div", { className: f, style: m, children: [
    t ? /* @__PURE__ */ e("span", { className: "icon", children: t }) : null,
    /* @__PURE__ */ e("input", { ref: d, "aria-invalid": o || void 0, ...c }),
    r
  ] });
});
function In({ label: n, hint: t, error: r, optional: o, children: i }) {
  const l = $(), u = `${l}-hint`, c = `${l}-error`, d = re.map(i, (f) => {
    if (!oe(f)) return f;
    const m = f.props ?? {};
    return ie(f, {
      id: m.id ?? l,
      "aria-describedby": (r ? c : t ? u : void 0) ?? m["aria-describedby"]
    });
  });
  return /* @__PURE__ */ h("div", { className: "field", style: { marginBottom: 16 }, children: [
    /* @__PURE__ */ h(
      "label",
      {
        htmlFor: l,
        className: "field-label",
        style: {
          display: "flex",
          justifyContent: "space-between",
          fontSize: 13,
          fontWeight: 500,
          color: "var(--color-text-primary)",
          marginBottom: 6
        },
        children: [
          /* @__PURE__ */ e("span", { children: n }),
          o ? /* @__PURE__ */ e("span", { style: { color: "var(--color-text-tertiary)", fontWeight: 400 }, children: "необязательно" }) : null
        ]
      }
    ),
    d,
    t && !r ? /* @__PURE__ */ e("div", { id: u, className: "field-help", style: { marginTop: 6 }, children: t }) : null,
    r ? /* @__PURE__ */ e("div", { id: c, className: "field-error", role: "alert", style: { marginTop: 6 }, children: r }) : null
  ] });
}
const an = {
  default: "badge--neutral",
  warning: "badge--warning",
  success: "badge--success",
  danger: "badge--danger",
  info: "badge--info"
}, Ln = L(function({ variant: t = "default", size: r = "md", className: o, children: i, ...l }, u) {
  const c = ["badge", an[t], o].filter(Boolean).join(" ");
  return /* @__PURE__ */ e("span", { ref: u, className: c, ...l, children: i });
}), cn = {
  info: /* @__PURE__ */ e(G, { size: 18, "aria-hidden": "true" }),
  warning: /* @__PURE__ */ e(P, { size: 18, "aria-hidden": "true" }),
  danger: /* @__PURE__ */ e(F, { size: 18, "aria-hidden": "true" }),
  success: /* @__PURE__ */ e(O, { size: 18, "aria-hidden": "true" })
}, dn = {
  info: "status",
  warning: "status",
  success: "status",
  danger: "alert"
};
function An({
  variant: n,
  title: t,
  body: r,
  icon: o,
  action: i,
  className: l,
  children: u
}) {
  const c = ["banner", `banner--${n}`, l].filter(Boolean).join(" ");
  return /* @__PURE__ */ h("div", { className: c, role: dn[n], children: [
    o ?? cn[n],
    /* @__PURE__ */ h("div", { style: { flex: 1, minWidth: 0 }, children: [
      t ? /* @__PURE__ */ e("span", { className: "banner-title", children: t }) : null,
      r ? /* @__PURE__ */ e("span", { className: "banner-body", children: r }) : null,
      u
    ] }),
    i ? /* @__PURE__ */ e("div", { style: { flexShrink: 0 }, children: i }) : null
  ] });
}
function un(n) {
  if (!/^#[0-9a-f]{6}$/i.test(n)) throw new Error("Ожидается цвет #RRGGBB");
  const t = [1, 3, 5].map((o) => {
    const i = parseInt(n.slice(o, o + 2), 16) / 255;
    return i <= 0.04045 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4;
  }), r = t[0] * 0.2126 + t[1] * 0.7152 + t[2] * 0.0722;
  return (r + 0.05) / 0.05 >= 1.05 / (r + 0.05) ? "#000000" : "#ffffff";
}
const fn = {
  none: 0,
  sm: 12,
  md: 16,
  lg: 24
}, hn = {
  sm: "var(--radius-sm)",
  md: "var(--radius-md)",
  lg: "var(--radius-lg)"
}, Pn = L(function({ children: t, padding: r = "md", radius: o = "md", className: i, style: l, as: u = "div" }, c) {
  const d = typeof r == "number" ? r : fn[r], f = typeof o == "number" ? `${o}px` : hn[o], m = ["surface", i].filter(Boolean).join(" ");
  return /* @__PURE__ */ e(
    u,
    {
      ref: c,
      className: m,
      style: { padding: d, borderRadius: f, ...l },
      children: t
    }
  );
});
function pn() {
  return /* @__PURE__ */ h("div", { style: { display: "inline-flex", alignItems: "center", gap: 10 }, children: [
    /* @__PURE__ */ e(
      "span",
      {
        "aria-hidden": "true",
        style: {
          width: 32,
          height: 32,
          borderRadius: 8,
          background: "var(--color-accent)",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 800,
          fontSize: 14,
          letterSpacing: "-0.02em"
        },
        children: "D"
      }
    ),
    /* @__PURE__ */ h("div", { style: { lineHeight: 1.1 }, children: [
      /* @__PURE__ */ e("div", { style: { fontWeight: 700, fontSize: 15, color: "var(--color-text-primary)" }, children: "DS2B" }),
      /* @__PURE__ */ e("div", { style: { fontSize: 11, color: "var(--color-text-tertiary)" }, children: "Портал оптовых заказов" })
    ] })
  ] });
}
function mn({ brand: n }) {
  return /* @__PURE__ */ h("div", { style: { display: "inline-flex", alignItems: "center", gap: 10, minWidth: 0 }, children: [
    /* @__PURE__ */ e(
      "span",
      {
        "aria-hidden": "true",
        style: {
          width: 32,
          height: 32,
          borderRadius: 8,
          background: n.color,
          color: un(n.color),
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 800,
          fontSize: 13,
          letterSpacing: "-0.02em"
        },
        children: n.short
      }
    ),
    /* @__PURE__ */ h("div", { style: { lineHeight: 1.3, minWidth: 0, overflowWrap: "anywhere" }, children: [
      /* @__PURE__ */ e("div", { style: { fontWeight: 700, fontSize: 15, color: "var(--color-text-primary)" }, children: n.name }),
      /* @__PURE__ */ e("div", { style: { fontSize: 11, color: "var(--color-text-tertiary)" }, children: "на платформе DS" })
    ] })
  ] });
}
const gn = "var(--color-bg-app)";
function Dn({ children: n, brand: t, mobile: r = !1, footer: o }) {
  return /* @__PURE__ */ h(
    "div",
    {
      className: "ds-auth-screen",
      style: {
        width: "100%",
        minHeight: "100dvh",
        background: gn,
        display: "flex",
        flexDirection: "column",
        fontFamily: "var(--font-sans)"
      },
      children: [
        /* @__PURE__ */ e(
          "header",
          {
            style: {
              height: r ? 56 : 72,
              padding: r ? "0 16px" : "0 32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexShrink: 0
            },
            children: t ? /* @__PURE__ */ e(mn, { brand: t }) : /* @__PURE__ */ e(pn, {})
          }
        ),
        /* @__PURE__ */ e(
          "main",
          {
            style: {
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: r ? "12px 16px 24px" : "24px"
            },
            children: /* @__PURE__ */ e("div", { style: { width: r ? 343 : 480, maxWidth: "100%" }, children: n })
          }
        ),
        /* @__PURE__ */ e(
          "footer",
          {
            style: {
              padding: r ? "12px 16px 16px" : "16px 32px 24px",
              display: "flex",
              flexWrap: "wrap",
              gap: "8px 24px",
              justifyContent: "space-between",
              fontSize: 13,
              color: "var(--color-text-tertiary)",
              flexShrink: 0
            },
            children: o ?? /* @__PURE__ */ h(V, { children: [
              /* @__PURE__ */ h("span", { children: [
                "© ",
                (/* @__PURE__ */ new Date()).getFullYear(),
                " DS2B"
              ] }),
              /* @__PURE__ */ e("p", { style: { margin: 0, maxWidth: "60ch", color: "var(--color-text-secondary)" }, children: "Нужна помощь со входом? Обратитесь к тому, кто вас пригласил, или к представителю вашего дистрибьютора." })
            ] })
          }
        )
      ]
    }
  );
}
const E = /* @__PURE__ */ new Set();
let X = "", N = null;
const Y = q(null);
function Mn({
  open: n,
  onClose: t,
  title: r,
  children: o,
  footer: i,
  closeOnOverlayClick: l = !0,
  width: u = 480,
  ariaLabel: c
}) {
  const d = B(null), f = B(null), m = Z(Y), y = B({ open: n, onClose: t });
  y.current = { open: n, onClose: t };
  const w = B(/* @__PURE__ */ new WeakMap()), R = $(), C = r != null && r !== !1 && r !== "", b = A(() => {
    const a = /* @__PURE__ */ new Set(), g = () => {
      const s = d.current;
      !y.current.open || !(s != null && s.isConnected) || (m == null || m.ensureOpen(), !s.open && (E.has(s) || (f.current = document.activeElement instanceof HTMLElement ? document.activeElement : null, E.size || (X = document.body.style.overflow, document.body.style.overflow = "hidden"), E.add(s)), s.showModal(), a.forEach((S) => S.promote())));
    };
    return { children: a, ensureOpen: g, promote: () => {
      const s = d.current;
      s != null && s.open && (w.current.set(s, (w.current.get(s) ?? 0) + 1), s.close()), g();
    } };
  }, [m]);
  return I(() => {
    const a = d.current;
    if (!n || !a) return;
    const g = w.current;
    return m == null || m.children.add(b), b.ensureOpen(), () => {
      m == null || m.children.delete(b), a.open && (g.set(a, (g.get(a) ?? 0) + 1), a.close()), E.delete(a), E.size || (document.body.style.overflow = X);
      const s = f.current, S = (s == null ? void 0 : s.isConnected) && (!E.size || [...E].some((k) => k.contains(s)));
      S ? s.focus() : s != null && s.isConnected && (N ?? (N = s)), E.size || (!S && (N != null && N.isConnected) && N.focus(), N = null);
    };
  }, [n, m, b]), I(() => {
    const a = d.current;
    if (!n || !a || (a.setAttribute("closedby", l ? "any" : "closerequest"), "closedBy" in a || !l)) return;
    let g = !1;
    const s = (v) => {
      const T = a.getBoundingClientRect();
      return v.target === a && (v.clientX < T.left || v.clientX > T.right || v.clientY < T.top || v.clientY > T.bottom);
    }, S = (v) => {
      g = s(v);
    }, k = (v) => {
      g && s(v) && y.current.onClose(), g = !1;
    };
    return a.addEventListener("pointerdown", S), a.addEventListener("click", k), () => {
      a.removeEventListener("pointerdown", S), a.removeEventListener("click", k);
    };
  }, [n, l]), !n || typeof document > "u" ? null : Q(
    /* @__PURE__ */ e(Y.Provider, { value: b, children: /* @__PURE__ */ h(
      "dialog",
      {
        ref: d,
        className: "ds-modal",
        style: { width: u },
        "aria-label": c,
        "aria-labelledby": !c && C ? R : void 0,
        onCancel: (a) => {
          a.preventDefault(), a.stopPropagation(), y.current.onClose();
        },
        onClose: (a) => {
          a.stopPropagation();
          const g = a.currentTarget, s = w.current.get(g) ?? 0;
          if (s) {
            w.current.set(g, s - 1);
            return;
          }
          y.current.open && (y.current.onClose(), queueMicrotask(() => {
            y.current.open && g.isConnected && d.current === g && !g.open && b.ensureOpen();
          }));
        },
        children: [
          C && /* @__PURE__ */ h("header", { className: "ds-modal__header", children: [
            /* @__PURE__ */ e("div", { id: R, className: "ds-modal__title", children: r }),
            /* @__PURE__ */ e(
              "button",
              {
                type: "button",
                className: "btn btn--ghost btn--sm btn--icon",
                "aria-label": "Закрыть",
                onClick: () => y.current.onClose(),
                children: /* @__PURE__ */ e(D, { size: 16, "aria-hidden": "true" })
              }
            )
          ] }),
          /* @__PURE__ */ e("div", { className: "ds-modal__body", children: o }),
          i && /* @__PURE__ */ e("footer", { className: "ds-modal__footer", children: i })
        ]
      }
    ) }),
    document.body
  );
}
const yn = {
  info: /* @__PURE__ */ e(G, { size: 18, "aria-hidden": "true" }),
  success: /* @__PURE__ */ e(O, { size: 18, "aria-hidden": "true" }),
  warning: /* @__PURE__ */ e(P, { size: 18, "aria-hidden": "true" }),
  danger: /* @__PURE__ */ e(F, { size: 18, "aria-hidden": "true" })
}, bn = {
  "top-right": { top: 16, right: 16 },
  "bottom-right": { bottom: 16, right: 16 },
  "top-center": { top: 16, left: "50%", transform: "translateX(-50%)" },
  "bottom-center": { bottom: 16, left: "50%", transform: "translateX(-50%)" }
};
function Wn({
  open: n,
  onClose: t,
  variant: r = "info",
  title: o,
  body: i,
  duration: l = 5e3,
  position: u = "top-right"
}) {
  if (I(() => {
    if (!n || l <= 0) return;
    const f = window.setTimeout(t, l);
    return () => window.clearTimeout(f);
  }, [n, l, t]), !n || typeof document > "u") return null;
  const d = /* @__PURE__ */ e("div", { role: "alert", style: { ...{
    position: "fixed",
    zIndex: "var(--z-toast, 1400)",
    minWidth: 280,
    maxWidth: 420
  }, ...bn[u] }, children: /* @__PURE__ */ h("div", { className: `banner banner--${r}`, style: { boxShadow: "var(--shadow-lg)" }, children: [
    yn[r],
    /* @__PURE__ */ h("div", { style: { flex: 1, minWidth: 0 }, children: [
      o ? /* @__PURE__ */ e("span", { className: "banner-title", children: o }) : null,
      i ? /* @__PURE__ */ e("span", { className: "banner-body", children: i }) : null
    ] }),
    /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: "btn btn--ghost btn--sm btn--icon",
        "aria-label": "Закрыть уведомление",
        onClick: t,
        children: /* @__PURE__ */ e(D, { size: 14, "aria-hidden": "true" })
      }
    )
  ] }) });
  return Q(d, document.body);
}
function vn(n, t) {
  return t <= 0 ? "…" : n.length <= t ? n : n.slice(0, t) + "…";
}
function xn({
  text: n,
  maxChars: t = 40,
  as: r = "span",
  href: o,
  fallback: i = "—",
  className: l,
  style: u
}) {
  const c = n ?? "";
  if (!c)
    return r === "a" && o ? /* @__PURE__ */ e("a", { ...{ href: o, className: l, style: u }, children: i }) : /* @__PURE__ */ e("span", { ...{ className: l, style: u }, children: i });
  const d = vn(c, t), f = d !== c;
  return r === "a" && o ? /* @__PURE__ */ e("a", { ...{
    href: o,
    className: l,
    style: u,
    title: f ? c : void 0,
    "aria-label": f ? c : void 0
  }, children: d }) : /* @__PURE__ */ e("span", { ...{
    className: l,
    style: u,
    title: f ? c : void 0,
    "aria-label": f ? c : void 0
  }, children: d });
}
function _n({
  label: n,
  selectedIds: t,
  onChange: r,
  options: o,
  searchValue: i,
  onSearchChange: l,
  searchPlaceholder: u = "Поиск…",
  loading: c = !1,
  error: d = !1,
  emptyMessage: f = "Нет данных.",
  emptySearchMessage: m = "Ничего не найдено.",
  panelWidth: y = 320,
  listMaxHeight: w = 180,
  optionMaxChars: R = 40,
  dataTestidPrefix: C
}) {
  const [b, a] = _(!1), g = B(null), s = B(null), S = $(), k = A(() => new Set(t), [t]);
  I(() => {
    if (!b) return;
    const p = (z) => {
      var H;
      z.key === "Escape" && (a(!1), (H = s.current) == null || H.focus());
    }, x = (z) => {
      g.current && (g.current.contains(z.target) || a(!1));
    };
    return document.addEventListener("keydown", p), document.addEventListener("mousedown", x), () => {
      document.removeEventListener("keydown", p), document.removeEventListener("mousedown", x);
    };
  }, [b]);
  const v = (p) => {
    k.has(p) ? r(t.filter((x) => x !== p)) : r([...t, p]);
  }, T = () => r([]), ne = A(() => {
    if (t.length === 0) return "";
    const p = o.filter((x) => k.has(x.id));
    return p.length === 0 ? `${t.length}` : p.length < t.length ? `${p.length} из ${t.length}` : p.length <= 2 ? p.map((x) => x.name).join(", ") : `${p.length} выбрано`;
  }, [o, k, t.length]), M = t.length > 0, te = typeof i == "string" && i.length > 0;
  return /* @__PURE__ */ h("div", { ref: g, style: { position: "relative" }, children: [
    /* @__PURE__ */ h(
      "button",
      {
        ref: s,
        type: "button",
        onClick: () => a((p) => !p),
        "aria-haspopup": "listbox",
        "aria-expanded": b,
        "aria-controls": b ? S : void 0,
        style: {
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          fontSize: 13,
          padding: "4px 10px",
          borderRadius: 6,
          border: "1px solid var(--color-border-subtle)",
          background: M ? "var(--color-bg-selected, rgba(26,115,232,0.08))" : "var(--color-surface)",
          cursor: "pointer"
        },
        children: [
          /* @__PURE__ */ e("span", { children: n }),
          M ? /* @__PURE__ */ h("span", { style: { fontSize: 12, color: "var(--color-text-tertiary)" }, children: [
            "· ",
            ne
          ] }) : null,
          /* @__PURE__ */ e("span", { "aria-hidden": !0, style: { fontSize: 10 }, children: b ? "▲" : "▼" })
        ]
      }
    ),
    b ? /* @__PURE__ */ h(
      "div",
      {
        style: {
          position: "absolute",
          top: "calc(100% + 4px)",
          left: 0,
          zIndex: 10,
          width: y,
          background: "var(--color-surface)",
          border: "1px solid var(--color-border-subtle)",
          borderRadius: 6,
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
          padding: 8,
          display: "flex",
          flexDirection: "column",
          gap: 8
        },
        children: [
          l ? /* @__PURE__ */ e(
            sn,
            {
              type: "search",
              placeholder: u,
              value: i ?? "",
              onChange: (p) => l(p.currentTarget.value)
            }
          ) : null,
          /* @__PURE__ */ e(
            "div",
            {
              id: S,
              role: "listbox",
              "aria-label": typeof n == "string" ? n : void 0,
              "aria-multiselectable": !0,
              style: {
                maxHeight: w,
                overflowY: "auto",
                border: "1px solid var(--color-border-subtle)",
                borderRadius: 6,
                background: "var(--color-surface)"
              },
              children: c ? /* @__PURE__ */ e("div", { style: W, children: "Загружаю…" }) : d ? /* @__PURE__ */ e("div", { style: { ...W, color: "var(--color-danger-fg)" }, children: "Не удалось загрузить список." }) : o.length === 0 ? /* @__PURE__ */ e("div", { style: W, children: te ? m : f }) : o.map((p) => {
                const x = k.has(p.id);
                return /* @__PURE__ */ h(
                  "div",
                  {
                    role: "option",
                    "aria-selected": x,
                    onClick: () => v(p.id),
                    onKeyDown: (z) => {
                      (z.key === " " || z.key === "Enter") && (z.preventDefault(), v(p.id));
                    },
                    tabIndex: 0,
                    "data-testid": C ? `${C}-${p.id}` : void 0,
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "6px 10px",
                      cursor: "pointer",
                      fontSize: 13,
                      background: x ? "var(--color-bg-selected, rgba(26,115,232,0.08))" : "transparent"
                    },
                    children: [
                      /* @__PURE__ */ e(
                        "input",
                        {
                          type: "checkbox",
                          checked: x,
                          readOnly: !0,
                          tabIndex: -1,
                          style: { flexShrink: 0, pointerEvents: "none" }
                        }
                      ),
                      /* @__PURE__ */ e(xn, { text: p.name, maxChars: R })
                    ]
                  },
                  p.id
                );
              })
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                color: "var(--color-text-tertiary)"
              },
              children: [
                /* @__PURE__ */ h("span", { children: [
                  "Выбрано: ",
                  t.length
                ] }),
                M ? /* @__PURE__ */ e(
                  "button",
                  {
                    type: "button",
                    onClick: T,
                    style: wn,
                    "data-testid": C ? `${C}-clear` : void 0,
                    children: "Сбросить"
                  }
                ) : null
              ]
            }
          )
        ]
      }
    ) : null
  ] });
}
const W = {
  padding: 12,
  fontSize: 13,
  color: "var(--color-text-secondary)",
  textAlign: "center"
}, wn = {
  background: "transparent",
  border: "none",
  color: "var(--color-text-link, #1a73e8)",
  cursor: "pointer",
  fontSize: 12,
  padding: 0
}, Sn = {
  // Каталог / товары
  Package: tn,
  Box: nn,
  Boxes: en,
  // Заказы / платежи
  Cart: U,
  ShoppingCart: U,
  Receipt: Je,
  File: () => null,
  // используется редко; подключим явно при первой нужде
  // Склад / точка
  Warehouse: Qe,
  Building: Ze,
  Store: qe,
  // Люди / роли
  User: Ve,
  Users: Ke,
  Shield: Ye,
  Star: Xe,
  // Email / связь
  Mail: Ue,
  Link: He,
  QrCode: Ge,
  Bell: Fe,
  // Управление
  Settings: Oe,
  SlidersHorizontal: $e,
  Search: je,
  Filter: _e,
  Edit: We,
  Trash: Me,
  Copy: De,
  More: Pe,
  // Навигация
  Plus: Ae,
  Minus: Le,
  Check: Ie,
  CheckCircle: O,
  Close: D,
  X: D,
  ChevronDown: Be,
  ChevronUp: Ne,
  ChevronLeft: Te,
  ChevronRight: Re,
  ArrowRight: ze,
  ArrowUp: Ee,
  ArrowDown: ke,
  // Информация / статусы
  Info: G,
  Alert: P,
  AlertTriangle: P,
  XCircle: F,
  Clock: Ce,
  // Безопасность / доступ
  Eye: Se,
  EyeOff: we,
  Lock: xe,
  Key: ve,
  Logout: be,
  // Прочее
  Refresh: ye,
  Truck: ge,
  Download: me,
  CreditCard: pe,
  HelpCircle: he,
  Map: fe,
  Layers: ue,
  Grid: de,
  List: ce,
  Tag: ae,
  BarChart: se
}, Cn = {
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24
};
function jn({ name: n, size: t = "md", className: r, ariaLabel: o }) {
  const i = Sn[n];
  if (!i) return null;
  const l = typeof t == "number" ? t : Cn[t];
  return /* @__PURE__ */ e(i, { size: l, className: r, ...o ? { "aria-label": o, role: "img" } : { "aria-hidden": !0 } });
}
const J = "dss-theme", j = "auto", ee = q(null);
function K(n) {
  return n === "auto" ? typeof window > "u" ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : n;
}
function kn() {
  if (typeof window > "u") return j;
  try {
    const n = window.localStorage.getItem(J);
    if (n === "light" || n === "dark" || n === "auto") return n;
  } catch {
  }
  return j;
}
function $n({ children: n, defaultTheme: t = j }) {
  const [r, o] = _(() => kn() ?? t), [i, l] = _(() => K(r));
  I(() => {
    typeof document > "u" || (document.documentElement.setAttribute("data-theme", r), l(K(r)));
  }, [r]), I(() => {
    if (r !== "auto" || typeof window > "u") return;
    const d = window.matchMedia("(prefers-color-scheme: dark)"), f = () => l(d.matches ? "dark" : "light");
    return d.addEventListener("change", f), () => d.removeEventListener("change", f);
  }, [r]);
  const u = le((d) => {
    o(d);
    try {
      window.localStorage.setItem(J, d);
    } catch {
    }
  }, []), c = A(
    () => ({ theme: r, resolved: i, setTheme: u }),
    [r, i, u]
  );
  return /* @__PURE__ */ e(ee.Provider, { value: c, children: n });
}
function On() {
  const n = Z(ee);
  if (!n)
    throw new Error("useTheme must be used within a <ThemeProvider>");
  return n;
}
export {
  Dn as AuthScreen,
  Ln as Badge,
  An as Banner,
  Nn as Button,
  Pn as Card,
  mn as DistributorLockup,
  In as Field,
  Sn as ICON_REGISTRY,
  jn as Icon,
  sn as Input,
  Bn as InputGroup,
  Mn as Modal,
  _n as MultiSelectDropdown,
  pn as PlatformLockup,
  Pn as Surface,
  $n as ThemeProvider,
  Wn as Toast,
  xn as TruncatedName,
  un as brandForeground,
  vn as truncate,
  On as useTheme
};
//# sourceMappingURL=index.js.map
